import { render, staticRenderFns } from "./formCheckboxItems.vue?vue&type=template&id=dae4881c&"
import script from "./formCheckboxItems.vue?vue&type=script&lang=js&"
export * from "./formCheckboxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports